/* eslint-disable react/no-multi-comp */
import React from "react";
import { VariantBase } from "scmp-sdk/components/newsletter/newsletter-widget/variants/component";

import { HomepageThemeButtonDisplay } from "./homepage-theme-button-display";
import { Container, theme } from "./styles";

export { config as homepageThemeConfig } from "./config";
export { HomepageThemeButtonDisplay } from "./homepage-theme-button-display";
export { HomepageThemeFindOutMore } from "./homepage-theme-find-out-more";

export const HomepageTheme: React.FunctionComponent<{ children?: React.ReactNode }> = ({
  children,
  ...props
}) => (
  <VariantBase theme={theme}>
    <Container {...props}>{children}</Container>
  </VariantBase>
);

export const HomepageThemeSignUpButtonDisplay: React.FunctionComponent = () => (
  <HomepageThemeButtonDisplay>Get Our Newsletters</HomepageThemeButtonDisplay>
);

export const HomepageThemeFindOutMoreDisplay: React.FunctionComponent = () => (
  <HomepageThemeButtonDisplay>Find Out More</HomepageThemeButtonDisplay>
);

HomepageTheme.displayName = "HomepageTheme";
